import { Bookmark, UploadCloud } from "react-feather";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ingredientService from "../../../services/ingredientService";
import { routes } from "../../routes";
import { History } from "history";
import React, { ChangeEvent, useEffect, useState } from "react";
import { IApplicationState } from "../../../redux/reducers";
import { IPaginateList } from "../../../interfaces/pagination";
import { IIngredient } from "../../../interfaces/ingredient";
import ProductCard, { ProductCardData } from "../../../components/common/ProductCard";
import { PRODUCT_TYPE } from "../../../interfaces/products";

interface IProps extends RouteComponentProps {
	ingredient: any;
	history: any;
	role: any;
	setShowProductActions: any;
	addToPortfolio: (id: string) => Promise<any>;
	removeIngredient: (id: string) => Promise<any>;
	ingredients: IPaginateList<IIngredient[]>;
}
const SearchResultCardV2: React.FC<IProps> = ({
	ingredient,
	history,
	role,
	setShowProductActions,
	addToPortfolio,
	removeIngredient,
	ingredients
}) => {
	// Convert ingredient to product format for ProductCard
	const productData: ProductCardData = {
		id: ingredient.id,
		name: ingredient.jf_display_name,
		version: 1,
		image_uri: ingredient.image_url,
		brand: { name: ingredient.manufacturer?.name },
		manufacturer: ingredient.manufacturer,
		country: ingredient.country,
		has_recommendations: ingredient.is_star,
		recommendations_count: ingredient.is_star ? 1 : 0,
		price: ingredient.price
	};

	return (
		<ProductCard
			product={productData}
			productType={PRODUCT_TYPE.CONCEPT}
			variant="search"
			showActions={true}
			onAddToPortfolio={addToPortfolio}
			onRemoveFromPortfolio={removeIngredient}
			onShowProductActions={() => setShowProductActions(true)}
		/>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	ingredients: state.ingredient.ingredients
});

const mapDispatchToProps = {
	addToPortfolio: (id: string) => ingredientService.addIngredientToPortfolio(id),
	removeIngredient: (id: string) => ingredientService.removeIngredient(id)
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchResultCardV2));
